import React from 'react';
import { Link } from 'react-router-dom'; 
import { useAuthContext } from '../../hooks/useAuthContext.js';

const Home = () => {

  const {user} = useAuthContext()

  const onClick = () => {
    
        window.location.href = "/Register";
      
  };

  return (
    <div style={parentDivStyle}>
        <div style={headerTextStyle}> Affordable GovCon Insights</div>
        <div> X Contracts Now Open total of open contracts on dibs</div>
        {!user && (
        
        <div style={buttonContainerStyle}> 
          <button onClick={onClick} style={buttonStyle}>Get Started Today</button>

        </div>
        )}

        
    </div>
  );
};

const headerTextStyle = {
  fontSize: '40px',
  lineHeight: '140%',
  fontFamily: 'Inter',
}

const buttonContainerStyle = {
  display: 'grid',
  gap: '1.5rem',
  justifyContent: 'center',
  paddingTop: '2.5rem'
}

const parentDivStyle = {
  justifyContent: 'center',
  display: 'grid',
  paddingTop: '10rem'
}

const buttonStyle = {
  fontSize: '16px',
  height: '50px',
  width: '300px',
  lineHeight: '140%',
  fontFamily: 'Inter',
  backgroundColor: '#213575',
  borderRadius: '5px',
  color:'white',
  border: '2px solid #213575',
  cursor: 'pointer'
}



export default Home;